
import {LocalDate} from '@js-joda/core';
import {EntityModel} from '../core/model/entity.model';
import {PurchaseRequestLine} from './purchase-request-line';

export class PurchaseRequest extends EntityModel {
  public consecutive?: string;
  public initialDecisionCode?: string;
  public initialDecisionDate?: LocalDate;
  public description?: string;
  public totalAmountToCommit?: number;
  public lines: PurchaseRequestLine[] = [];
}
